import * as Popover from '@radix-ui/react-popover'
import {
	NodeViewContent,
	NodeViewWrapper,
	type NodeViewProps,
} from '@tiptap/react'
import { CircleMinus, CirclePlus } from 'lucide-react'
import { Button } from '#app/components/ui/button.js'
import { CUSTOMIZER_MAX_WIDTH } from '#app/utils/constants.js'

const Component = (props: NodeViewProps) => {
	const isEmpty = props.node.childCount === 0
	const { editor } = props

	const handleAddNewBlock = () => {
		const pos = props.getPos()
		editor.commands.setNodeSelection(pos)
		editor.commands.blur()
		props.extension.options.setTab('blocks')
	}

	const addColumn = () => {
		if (editor) {
			const nodeEndPos = props.getPos() + props.node.nodeSize
			editor
				.chain()
				.focus()
				.insertContentAt(nodeEndPos, '<column></column>')
				.blur()
				.run()
		}
	}

	const removeColumn = () => {
		if (editor) {
			const currentPos = props.getPos()

			editor
				.chain()
				.focus()
				.deleteRange({
					from: currentPos,
					to: currentPos + props.node.nodeSize,
				})
				.blur()
				.run()
		}
	}

	return (
		<NodeViewWrapper
			as="td"
			data-type="column"
			valign="top"
			width={CUSTOMIZER_MAX_WIDTH + 'px'}
		>
			<div className="flex w-full">
				<Popover.Root>
					<Popover.Trigger className="flex w-full">
						{isEmpty ? (
							<div className="flex aspect-video w-full cursor-pointer flex-col items-center justify-center gap-3 rounded-lg border border-dashed bg-primary p-6 font-medium">
								<Button
									size="s"
									className="flex gap-2"
									onClick={handleAddNewBlock}
								>
									<CirclePlus width={16} />
								</Button>
							</div>
						) : (
							<NodeViewContent />
						)}
					</Popover.Trigger>
					<Popover.Portal>
						<Popover.Content
							onOpenAutoFocus={e => e.preventDefault()}
							className="custom-popover z-50 flex items-center gap-2 rounded-xl border border-border bg-white p-2 shadow-sm"
							sideOffset={8}
						>
							<div className="flex items-center gap-2">
								<div className="flex">
									<Button
										onClick={removeColumn}
										data-tooltip="Remove input"
										data-tooltip-direction="up"
										className="flex h-[32px] w-[32px] items-center justify-center	 rounded-lg rounded-r-none border border-border bg-primary-foreground transition-all duration-150 ease-in-out group-hover:-rotate-6 group-hover:shadow-sm"
									>
										<CircleMinus width={16} className="shrink-0" />
									</Button>
									<Button
										onClick={addColumn}
										data-tooltip="Add input"
										data-tooltip-direction="up"
										className="flex h-[32px] w-[32px] items-center justify-center rounded-lg rounded-l-none border border-l-0 border-border bg-primary-foreground transition-all duration-150 ease-in-out group-hover:-rotate-6 group-hover:shadow-sm"
									>
										<CirclePlus width={16} className="shrink-0" />
									</Button>
								</div>
							</div>
						</Popover.Content>
					</Popover.Portal>
				</Popover.Root>
			</div>
		</NodeViewWrapper>
	)
}

export default Component
